import {node_observable_component} from 'common/util/ComponentDecorator';
import './our-clients.scss';

@node_observable_component
export default class OurClients {
	static classname = 'our-clients';

	constructor(clients) {
		this.$clients = clients;
		this.initSlider();
	}

	initSlider = () => {
		new Swiper(this.$clients.find('.swiper-container'), {
			slidesPerColumn: 2,
			slidesPerView: 4,
			mousewheel: {
				forceToAxis: true
			},
			navigation: {
				nextEl: this.$clients.find('.our-clients__title-btn_next'),
				prevEl: this.$clients.find('.our-clients__title-btn_prev')
			},
			breakpoints: {
				1200: {
					slidesPerView: 3,
				},
				900: {
					slidesPerColumn: 1,
					slidesPerView: "auto"
				}
			}
		});
	}
};
